module.exports = "/images/Support.svg";